export default __webpack_public_path__ + "static/media/jhipster.05ef9778.svg";